"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MallRequest = void 0;
var MallRequest = /** @class */ (function () {
    function MallRequest() {
    }
    return MallRequest;
}());
exports.MallRequest = MallRequest;
;
//# sourceMappingURL=mall.request.js.map